module.exports = __webpack_public_path__ + "img/logoSonam.fd30468d.jpg";